import React from 'react';
import { useTranslation } from 'react-i18next';
import { Quote, Star } from 'lucide-react';
import { Container, Reveal, SectionLabel } from './primitives';

export default function ClientStories() {
  const { t } = useTranslation();

  const stories = t('home.stories.items', { returnObjects: true });
  const items = Array.isArray(stories) ? stories : [];

  return (
    <section id="stories" className="bg-ink py-20 sm:py-28">
      <Container>
        <Reveal className="mx-auto max-w-2xl text-center">
          <SectionLabel>{t('home.stories.eyebrow')}</SectionLabel>
          <h2 className="mt-5 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {t('home.stories.title')}
          </h2>
          {t('home.stories.subtitle') && (
            <p className="mt-4 text-lg text-white/55">{t('home.stories.subtitle')}</p>
          )}
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2">
          {items.map((item, i) => (
            <Reveal
              key={i}
              delay={i * 80}
              className="flex h-full flex-col rounded-2xl border border-line bg-surface p-7"
            >
              <Quote className="h-7 w-7 text-accent/40" />
              <div className="mt-3 flex gap-0.5">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-accent text-accent" />
                ))}
              </div>
              <p className="mt-4 flex-1 text-[15px] leading-relaxed text-white/70">"{item.quote}"</p>

              <div className="mt-6 flex items-center gap-3 border-t border-line pt-5">
                {/* Avatar placeholder — swap for real photo when available */}
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-accent-gradient text-sm font-bold text-white">
                  {(item.name || '?').charAt(0)}
                </span>
                <div>
                  <div className="text-sm font-semibold text-white">{item.name}</div>
                  <div className="text-xs text-accent-400">
                    {[item.role, item.company].filter(Boolean).join(' · ')}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
